// ============================================================================
// ZoomToolbar — [−] 150% [+] [Fit] controls for the crop image viewer
// ============================================================================

import { Box, Button, HStack, Text } from '@chakra-ui/react';
import { AddIcon, MinusIcon } from '@chakra-ui/icons';
// ADMIN_COLORS available if needed for future styling

interface ZoomToolbarProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
}

export function ZoomToolbar({ zoom, onZoomIn, onZoomOut, onReset }: ZoomToolbarProps) {
  const pct = Math.round(zoom * 100);
  const isMin = zoom <= 1;
  const isMax = zoom >= 5;

  return (
    <HStack
      gc-testing-id="crop-zoom-toolbar"
      spacing={0}
      bg="rgba(0,0,0,0.7)"
      borderRadius="md"
      overflow="hidden"
      userSelect="none"
    >
      <Button
        gc-testing-id="crop-zoom-out"
        size="xs"
        variant="ghost"
        color="white"
        _hover={{ bg: 'rgba(255,255,255,0.15)' }}
        _disabled={{ opacity: 0.3, cursor: 'default' }}
        isDisabled={isMin}
        onClick={onZoomOut}
        minW="28px"
        h="28px"
        px={1}
        borderRadius={0}
      >
        <MinusIcon boxSize={2.5} />
      </Button>

      <Box
        gc-testing-id="crop-zoom-level"
        as="button"
        px={2}
        h="28px"
        display="flex"
        alignItems="center"
        cursor="pointer"
        _hover={{ bg: 'rgba(255,255,255,0.1)' }}
        onClick={onReset}
        title="Reset to fit"
      >
        <Text fontSize="xs" color="white" fontWeight="medium" fontFamily="mono">
          {pct}%
        </Text>
      </Box>

      <Button
        gc-testing-id="crop-zoom-in"
        size="xs"
        variant="ghost"
        color="white"
        _hover={{ bg: 'rgba(255,255,255,0.15)' }}
        _disabled={{ opacity: 0.3, cursor: 'default' }}
        isDisabled={isMax}
        onClick={onZoomIn}
        minW="28px"
        h="28px"
        px={1}
        borderRadius={0}
      >
        <AddIcon boxSize={2.5} />
      </Button>

      {zoom > 1 && (
        <Button
          gc-testing-id="crop-zoom-fit"
          size="xs"
          variant="ghost"
          color="white"
          _hover={{ bg: 'rgba(255,255,255,0.15)' }}
          onClick={onReset}
          minW="28px"
          h="28px"
          px={2}
          borderRadius={0}
          borderLeft="1px solid rgba(255,255,255,0.2)"
        >
          <Text fontSize="2xs">Fit</Text>
        </Button>
      )}
    </HStack>
  );
}
